import endpoints, { axios } from "../config/api";

function getTaskTemplate(templateId: number) {
  return axios.get(endpoints.taskTemplates.get(templateId));
}

export default getTaskTemplate;
